import {useEffect, useState} from 'react';

import {useLazyFetchProblemQuery} from '@api';
import {SingleProblem} from '@types';

export const useProblem = (problemId?: number | null) => {
    const [fetchProblem] = useLazyFetchProblemQuery();

    const [problem, setProblem] = useState<SingleProblem>();
    const [update, setUpdate] = useState<number>(0);

    useEffect(() => {
        if (!problemId) return;
        async function fetchProblemData(id: number) {
            try {
                const response = await fetchProblem(id).unwrap();
                setProblem(response);
            } catch (error) {
                console.error('fetch problem failed');
            }
        }
        void fetchProblemData(problemId);
    }, [fetchProblem, problemId, update]);

    const refetch = () => {
        setUpdate(update => (update += 1));
    };

    return {problem, setProblem, problemId, refetch};
};
